var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _c(
            "el-col",
            { staticClass: "labelLogradouro", attrs: { span: 12 } },
            [
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Logradouro:")]),
                _c("span", { staticClass: "breakText" }, [
                  _vm._v("  " + _vm._s(_vm.filterNull(_vm.endereco.logradouro)))
                ])
              ])
            ]
          ),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Número:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNumber(_vm.endereco.numero)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Complemento:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.endereco.complemento)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Bairro:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.endereco.bairro)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("CEP:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.endereco.cep)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("UF:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " +
                    _vm._s(_vm.filterNull(_vm.endereco.municipio.codigoEstado))
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Município:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " + _vm._s(_vm.filterNull(_vm.endereco.municipio.nome))
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-221f5d8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-221f5d8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoEndereco.vue
// module id = null
// module chunks = 